import { Connection } from '@/utils';

export class OutagePlanningService {
    private api: Connection = new Connection();

    public async getPlanning(groupId: number, startYear: number): Promise<any> {
        const query = { params: { startYear: startYear } };
        return (await this.api.get('OutagePlanning/' + groupId, query)).data.result;
    }
}
